import { render, staticRenderFns } from "./QuoteInvoice.vue?vue&type=template&id=bf8e8544&scoped=true"
import script from "./QuoteInvoice.vue?vue&type=script&lang=js"
export * from "./QuoteInvoice.vue?vue&type=script&lang=js"
import style0 from "./QuoteInvoice.vue?vue&type=style&index=0&id=bf8e8544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8e8544",
  null
  
)

export default component.exports